export default __webpack_public_path__ + "img/WB_RTK_NOMA_BF.96655def955518729bb3ae588b136276.jpg";